jQuery(document).ready(function() {
   jQuery('.collection-roundells').slick({
     dots: false,
     speed: 500,
     infinite:false,
    arrows:true,
     slidesToShow: 9,
     slidesToScroll: 1,
     responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 6
      }
    },
           {
      breakpoint: 1001,
      settings: {
        slidesToShow: 5
      }
    },
       {
      breakpoint: 768,
      settings: {
        slidesToShow: 4
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2.5
      }
    }
  ]
   });
 });





$(document).ready(function(){


		jQuery('#southwood_usp').slick({
			dots: false,
			infinite: true,
			arrows: false,
			autoplay: true,
			autoplaySpeed: 3000,
			slidesToShow: 4,
			slidesToScroll: 1,
			responsive: [
                {
				breakpoint: 1000,
				settings: {
					slidesToShow: 3
				}
			},
                {
				breakpoint: 750,
				settings: {
					slidesToShow: 2
				}
			},
            {
				breakpoint: 500,
				settings: {
					slidesToShow: 1
				}
			}]
		});	
});

